module.exports = __webpack_public_path__ + "img/offer-1.77b0dadf.webp";